import React from 'react';
import PropTypes from 'prop-types';
import * as user from './../../model/user';
import * as usersApi from './../../api/users-api';
import i18next, * as i18nexaddt from 'i18next';
import ModalDialog from './../utils/ModalDialog';
import TextInput from './../utils/TextInput';
import Form from './../utils/Form';
import SelectInput from './../utils/SelectInput';
import * as blockUtils from './../../utils/BlockUtils';
import FormComponent from './../utils/FormComponent';
import ErrorBox from './../utils/ErrorBox';
import {getErrorDescription} from '../../utils/view-utils';

class EditOwnUserForm extends FormComponent {
  constructor(props) {
    super(props);

    this.sendForm = this.sendForm.bind(this);
    this.validateUsername = this.validateUsername.bind(this);
  }

  initialState() {
    const userObject = user.toUserObject(this.props.user);
    userObject['roleText'] = i18next.t([`users.roles.${this.props.user.role}`]);
    return userObject;
  }

  sendForm() {
    if (this.validateEmail()) {
      if (this.state.id) {
        usersApi.updateOwnUser(this.state).then(() => {
          blockUtils.unblockUI();
          $(`#${this.props.dialogId}`).modal('hide');
        }).catch((err) => {
          blockUtils.unblockUI();
          this.handleError(err);
        });
        blockUtils.blockUI();
      }
    }
  }

  validateUsername() {
    if (this.state.username) {
      this.setState({usernameError: ''});
      return true;
    } else {
      this.setState({usernameError: i18next.t('errors.is_required', {field: i18nexaddt.t('users.attrs.login')})});
      return false;
    }
  }

  validateEmail() {
    if (this.state.email) {
      this.setState({emailError: ''});
      return true;
    } else {
      this.setState({emailError: i18next.t('errors.is_required', {field: i18next.t('users.attrs.email')})});
      return false;
    }
  }

  handleError(error) {
    this.setState({
      error: error,
    });
  }

  render() {
    return (
      <ModalDialog
        modalTitle={i18next.t('users.edit', {username: this.state.username})}
        dialogId={this.props.dialogId}
        onDialogHide={blockUtils.unblockUI}
        onDialogShown={this.onFormShow}
        onSubmit={this.sendForm}
      >

        <Form>
          <ErrorBox errorMessage={getErrorDescription(this.state.error)} />

          <TextInput
            fieldId="username"
            labelText={i18next.t('users.attrs.login')}
            isRequired={true}
            error={this.state.usernameError}
            validate={this.validateUsername}
            onChange={this.onChange}
            value={this.state.username}
          />

          <TextInput
            fieldId="email"
            labelText={i18next.t('users.attrs.email')}
            onChange={this.onChange}
            value={this.state.email}
            error={this.state.emailError}
          />

          <SelectInput
            fieldId="language"
            labelText={i18next.t('users.attrs.language')}
            selected={this.state.language}
            onChange={this.onChange}
            values={user.UserLanguages}
          />

          <TextInput
            fieldId="role"
            labelText={i18next.t('users.attrs.role')}
            isReadonly={true}
            value={this.state.roleText}
          />

        </Form>
      </ModalDialog>
    );
  }
}

EditOwnUserForm.propTypes = {
  dialogId: PropTypes.string,
  user: PropTypes.object,
};

EditOwnUserForm.defaultProps = {};

export default EditOwnUserForm;
